<template>
  <section class="businesses">
    <main class="main" :class="{ 'expand-main': isMenuCollapse }">
      <div class="col-12" v-if="!add">
        <div class="">
            <Tabs
              :tabSelected="mainTabSelected"
              :tabs="mainTabs"
              @change="changeMainTab($event)"

            />
            <div class="mt-2 border-top border-grey border-2"></div>
        </div>

        <Step3 v-if="mainTabSelected == 1" :simplify="true" :targetId="$route.params.id" />
         <!--Show History orders -->
         <div v-if="mainTabSelected == 2">
          <TimeEvents
          :items="historyItems"
          :loading="loadingHistory"
          />
        </div>
      </div>
      <div class="row bg-light" v-if="add">
        <div class="col-2"></div>
          <MultiStep :addOrder="true" class="col-8"/>
        <div class="col-2"></div>
      </div>
    </main>
  </section>
</template>
<script>
import Step3 from "@/components/Onboarding/MultiSteps/Step3.vue";
import MultiStep from "@/components/Onboarding/MultiStep.vue";
import { mapState,mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import TimeEvents from "@/components/Common/TimeEvents.vue";
import Tabs from "@/components/Common/Tabs.vue";
import { targetsService } from "@/_services";


export default {
  data() {
    return {
      add:false,
      loadingHistory: true,
      historyItems: [],
      mainTabSelected: 1,
      targetId: 0,
      mainTabs: {
        1: {
          id: 1,
          name: this.$t('lang.label.order'),
        },
        2: {
          id: 2,
          name: this.$t('lang.label.history'),
        },
      },
    };
  },
  methods: {
    ...mapActions("onboarding", {
      setTypeForm:"setTypeForm",
    }),
    changeMainTab(itemSelected){
      this.mainTabSelected = itemSelected

      //If the tab selected is "History"
      if(itemSelected == 2) this.getOrderHistory()
    },
    getOrderHistory(){
      this.loadingHistory = true
      let data = {
          client_id: this.client_id,
          history: true,
          targetId: this.targetId
        };
        targetsService.getTargetListByClientAndStatus(data).then((response) => {

          if (response !== undefined) {
            this.loadingHistory = false;
            this.historyItems = response.historyEvents;
          }
        });
    },
  },
  computed: {
    ...mapState({
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      onBoarding: (state) => state.onboarding,
    }),
  },

  created() {
    if(this.$route.params.id == "add"){
      this.add = true;
      this.setTypeForm("add")
    } else {
      this.targetId = this.$route.params.id
    }
  },
  components: {
    Step3,
    MultiStep,
    LoadingSpinner,
    Tabs,
    TimeEvents
  },
};
</script>
